import { render, staticRenderFns } from "./DaySlotsPanel.vue?vue&type=template&id=57bb824c&scoped=true"
import script from "./DaySlotsPanel.vue?vue&type=script&lang=js"
export * from "./DaySlotsPanel.vue?vue&type=script&lang=js"
import style0 from "./DaySlotsPanel.vue?vue&type=style&index=0&id=57bb824c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bb824c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VAvatar,VBtn,VBtnToggle,VChip,VIcon,VSheet})
